/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from "react";
import { evidencePartsLookup } from "@constants/evidencePartsLookup";

interface LegacyEvidenceFieldsProps {
  legacyParts: string[];
  evidenceJSON: Record<string, any>;
  getLegacyEvidencePartType: (value: any) => string;
  renderLegacyEvidencePart: (type: string, value: any) => React.ReactNode;
}

const isEmptyValue = (value: any): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === "object" && Object.keys(value).length === 0) return true;
  return false;
};

const LegacyEvidenceFields: React.FC<LegacyEvidenceFieldsProps> = ({
  legacyParts,
  evidenceJSON,
  getLegacyEvidencePartType,
  renderLegacyEvidencePart,
}) => {
  if (legacyParts.length === 0) return null;

  const validLegacyParts = useMemo(() => {
    return legacyParts.filter((key) => {
      const value = evidenceJSON[key];
      return !isEmptyValue(value);
    });
  }, [legacyParts, evidenceJSON]);

  if (validLegacyParts.length === 0) return null;

  return (
    <div>
      <div className="flex flex-row items-center justify-between mt-4 gap-4">
        <div className="h-[1px] flex-1 bg-grey-30" />
        <div className="text-acc-12px font-acc-600 leading-acc-lh text-grey-90">{"Legacy Evidence Fields"}</div>
        <div className="h-[1px] flex-1 bg-grey-30" />
      </div>
      <>
        {validLegacyParts.map((key, index) => {
          const value = evidenceJSON[key];
          const displayTitle = evidencePartsLookup[key] ?? key;
          const type = getLegacyEvidencePartType(value);

          return (
            <div
              className="readEvidenceBlock"
              key={key}
            >
              <div className="readEvidenceHeader">{displayTitle}</div>
              {renderLegacyEvidencePart(type, value)}
              {index !== validLegacyParts.length - 1 && <div className="h-[1px] w-full bg-grey-30 mt-4" />}
            </div>
          );
        })}
      </>
    </div>
  );
};

export default LegacyEvidenceFields;
